export const ENTRIES_FETCH = 'data/entries_fetch';
export const ENTRIES_FETCH_SUCCESS = 'data/entries_fetch_success';
export const ENTRIES_FETCH_FAILURE = 'data/entries_fetch_failure';
export const TAGS_FETCH_SUCCESS = 'data/tags_fetch_success';

export const ENTRIES_ADDED = 'data/entries_added';
export const ENTRIES_UPDATED = 'data/entries_updated';
export const ENTRIES_DELETED = 'data/entries_removed';

export const LISTENER_ADD = "add_listener_to_data_changes";
export const UNLISTEN = "unlisten_to_data_changes"

export const ENTRY_UPDATE = 'data/entry_updated';
export const ENTRY_UPDATE_SUCCESS = 'data/entry_updated_success';
export const ENTRY_UPDATE_FAILURE = 'data/entry_updated_failure';
export const ENTRY_ADD = 'data/entry_added';
export const ENTRY_ADD_SUCCESS = 'data/entry_added_success';
export const ENTRY_ADD_FAILURE = 'data/entry_added_failure';
export const ENTRY_REMOVE = 'data/entry_removed';
export const ENTRY_REMOVE_SUCCESS = 'data/entry_remove_success';
export const ENTRY_REMOVE_FAILURE = 'data/entry_remove_failure';

export const TAGS_ADD_TO_ENTRY = "data/tags_add_to_entries";
export const TAGS_ADD_TO_ENTRY_SUCCESS = "data/tags_add_to_entries_success";
export const TAGS_ADD_TO_ENTRY_FAILURE = "data/tags_add_to_entries_failure";

export const TAGS_REMOVE_FROM_ENTRY = "data/tags_removed_from_entries";
export const TAGS_REMOVE_FROM_ENTRY_SUCCESS = "data/tags_removed_from_entries_success";
export const TAGS_REMOVE_FROM_ENTRY_FAILURE = "data/tags_removed_from_entries_fail";

export const TAGS_UPDATE_ON_ENTRY = "data/tags_udpated_on_entries";
export const TAGS_UPDATE_ON_ENTRY_SUCCESS = "data/tags_udpated_on_entries_success";
export const TAGS_UPDATE_ON_ENTRY_FAILURE = "data/tags_udpated_on_entries_failure";

export const TAG_DELETE = "data/tag_delete";
export const TAG_DELETE_SUCCESS = "data/tag_delete_succes";
export const TAG_DELETE_FAILURE = "data/tag_delete_failure";

/* -------------------------- */

export const HIGHLIGHT_ADD = 'data/higlight_added';
export const ARTICLE_ADD = 'data/article_added';

export const HIGHLIGHTS_FETCH_SUCCESS = 'data/highlights_fetch_success';
export const ARTICLES_FETCH_SUCCESS = 'data/articles_fetch_success';



// WEBPACK FOOTER //
// ./src/data/actionTypes.js